// extracted by mini-css-extract-plugin
module.exports = {"spin":"Loading_spin__189cK","spinLessPadding":"Loading_spinLessPadding__23t9K"};